import { React } from 'react';
import Cookie from '../cookies/cookie';
import Footer from '../footer/Footer';
import { useStyles } from './HomePage.module';
import IntegrityPillars from '../integrityPillars/integrityPillars';
import Hero from '../hero/hero';

const HomePage = () => {
  const classes = useStyles();
  return (
    <div>
      <Hero />
      <IntegrityPillars />
      <Footer />
      <Cookie />
    </div>
  );
};

export default HomePage;
